import axiosInstance from "../../interceptor";

const AppApi = {
  loadSettings: () => axiosInstance.get('/registry/google_key'),
  getRegistryValue: (key: string) => axiosInstance.get('/registry/' + key),
  setRegistryValue: (key: string, value: string) => axiosInstance.post('/registry/', {key: key, value: value})
};

export default AppApi;